// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider_container__3b4Oa","cover":"Slider_cover__5zPxC"};